import Swiper, { Navigation, Pagination, Lazy } from "swiper";
Swiper.use([Pagination, Navigation, Lazy]);

const initResultCoopSlier = () => {
  const slider = document.querySelector(".resultCoop__blocks");

  slider && new Swiper(slider, {
    breakpoints: {
      1441: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      980: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      750: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 7,
        centeredSlides: true,
      },
    },
    pagination: {
      el: '.paginaionBlock__fraction',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.paginationBlock__next',
      prevEl: '.paginationBlock__prev',
      disabledClass: 'lastSlide',
    },
  });
};

export default initResultCoopSlier;
